var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _dec21, _dec22, _dec23, _dec24, _dec25, _dec26, _dec27, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _temp;

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and set to use loose mode. ' + 'To use proposal-class-properties in spec mode with decorators, wait for ' + 'the next major version of decorators in stage 2.'); }

/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
import { Component, Prop, State, CustomElement, Watch, Event, EventEmitter, COMPONENT_STATE, Interceptor, classMap, html } from '@sick-davinci/ce-decorators';
import { style } from './Button.style';
import { Icon } from '../icon/Icon';
import { IconRef } from '../icon/IconRef';
const isTouch = window.navigator.msMaxTouchPoints > 0 || !!('ontouchstart' in window);
/**
 * A button which can be activated using mouse click, space- or enter-key. It can also be used as a toggle button.
 * Style can be influenced using the type and small attribute. If toggle is set, it can be used with a toggle-group.
 * 
 * @example
 * ```html
 * <davinci-button onclick="console.log('clicked')">Click me</davinci-button>
 * ```
 * @slot { * } content inside the button
 */

export let Button = (_dec = Component({
  tag: 'davinci-button',
  style: [style],
  dependencies: [Icon, IconRef]
}), _dec2 = Prop(), _dec3 = Reflect.metadata("design:type", Boolean), _dec4 = Prop({
  type: String
}), _dec5 = Reflect.metadata("design:type", String), _dec6 = Prop(), _dec7 = Reflect.metadata("design:type", String), _dec8 = Prop(), _dec9 = Reflect.metadata("design:type", String), _dec10 = Prop(), _dec11 = Reflect.metadata("design:type", Boolean), _dec12 = Prop(), _dec13 = Reflect.metadata("design:type", String), _dec14 = Prop(), _dec15 = Reflect.metadata("design:type", String), _dec16 = Prop(), _dec17 = Reflect.metadata("design:type", Boolean), _dec18 = State(), _dec19 = Reflect.metadata("design:type", Boolean), _dec20 = Event('change'), _dec21 = Reflect.metadata("design:type", typeof EventEmitter === "undefined" ? Object : EventEmitter), _dec22 = Event('submit'), _dec23 = Reflect.metadata("design:type", typeof EventEmitter === "undefined" ? Object : EventEmitter), _dec24 = Interceptor('type'), _dec25 = Reflect.metadata("design:paramtypes", [String, String]), _dec26 = Watch('disabled'), _dec27 = Reflect.metadata("design:paramtypes", [Boolean, Boolean]), _dec(_class = (_class2 = (_temp = class Button extends CustomElement {
  constructor(...args) {
    super(...args);

    _initializerDefineProperty(this, "selected", _descriptor, this);

    _initializerDefineProperty(this, "type", _descriptor2, this);

    _initializerDefineProperty(this, "icon", _descriptor3, this);

    _initializerDefineProperty(this, "iconSrc", _descriptor4, this);

    _initializerDefineProperty(this, "toggle", _descriptor5, this);

    _initializerDefineProperty(this, "name", _descriptor6, this);

    _initializerDefineProperty(this, "value", _descriptor7, this);

    _initializerDefineProperty(this, "disabled", _descriptor8, this);

    _initializerDefineProperty(this, "isempty", _descriptor9, this);

    _initializerDefineProperty(this, "changeEvent", _descriptor10, this);

    _initializerDefineProperty(this, "submitEvent", _descriptor11, this);

    this.slotchanged = () => {
      // workaround since we can not target text nodes in ::slotted to set or reset padding and host(:empty) does not work on ShadyCSS
      if (this.textContent) {
        this.isempty = false;
        this.classList.remove('empty');
      } else {
        this.isempty = true;
        this.classList.add('empty');
      }
    };

    this._onKeydownEvent = evt => {
      if (evt.key === 'Enter' || evt.key === ' ' || evt.key === 'Spacebar') {
        evt.preventDefault();
      }
    };

    this._onKeyupEvent = evt => {
      if (evt.key === 'Enter' || evt.key === ' ' || evt.key === 'Spacebar') {
        // browsers sends different keys
        this.dispatchEvent(new MouseEvent('click', {
          bubbles: true,
          cancelable: false
        }));
      }
    };

    this._onClickEvent = _event => {
      if (this.toggle) {
        this.selected = !this.selected;
        this.changeEvent.emit(this.selected);
      }

      this.submitEvent.emit();
    };
  }

  render() {
    return html`
      <div class="flexbox">
        ${this.renderIcon()}
        <div class="${classMap({
      slotwrapper: true,
      empty: this.isempty
    })}">
          <slot @slotchange="${this.slotchanged}"></slot>
        </div>
      </div>
    `;
  }

  componentConnected() {
    this.addEventListener('keydown', this._onKeydownEvent);
    this.addEventListener('keyup', this._onKeyupEvent);

    if (!isTouch) {
      this.addEventListener('mouseenter', this._onMouseEnter);
      this.addEventListener('mouseleave', this._onMouseLeave);
    }

    this._disabledChangeHandler(this.disabled, this.disabled);

    this.addEventListener('click', this._onClickEvent);
  }

  componentDisconnected() {
    this.removeEventListener('keydown', this._onKeydownEvent);
    this.removeEventListener('keyup', this._onKeyupEvent);

    if (!isTouch) {
      this.removeEventListener('mouseenter', this._onMouseEnter);
      this.removeEventListener('mouseleave', this._onMouseLeave);
    }

    this.removeEventListener('click', this._onClickEvent);
  }

  componentFirstRender() {
    this.slotchanged();
  }

  /* Fixes the API change on the type names */
  typeIntereptor(_oldvalue, newValue) {
    switch (newValue) {
      case 'secondary':
        {
          return 'outline';
        }

      case 'secondary-alt':
        {
          return 'outline-alt';
        }

      case 'tertiary':
        {
          return 'accent';
        }

      default:
        {
          return newValue;
        }
    }
  }

  renderIcon() {
    let icon = null;

    if (!!this.iconSrc) {
      icon = html`<davinci-icon-ref src=${this.iconSrc}></davinci-icon-ref>`;
    }

    if (!!this.icon) {
      icon = html`<davinci-icon icon=${this.icon}></davinci-icon>`;
    }

    return icon;
  }

  _onMouseEnter() {
    this.classList.add('entered');
  }

  _onMouseLeave() {
    this.classList.remove('entered');
  }

  _disabledChangeHandler(_, newValue) {
    if (this._componentState !== COMPONENT_STATE.INIT) {
      // avoid setting illegal attribute set during construction
      if (newValue) {
        this.tabIndex = -1;
        this.setAttribute('tabindex', '-1'); // not focussable anymore
      } else {
        this.tabIndex = 0;
        this.setAttribute('tabindex', '0');
      }
    }
  }

}, _temp), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "selected", [_dec2, _dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "type", [_dec4, _dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 'primary';
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "icon", [_dec6, _dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "iconSrc", [_dec8, _dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "toggle", [_dec10, _dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "name", [_dec12, _dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "value", [_dec14, _dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, "disabled", [_dec16, _dec17], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class2.prototype, "isempty", [_dec18, _dec19], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class2.prototype, "changeEvent", [_dec20, _dec21], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class2.prototype, "submitEvent", [_dec22, _dec23], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, "typeIntereptor", [_dec24, _dec25], Object.getOwnPropertyDescriptor(_class2.prototype, "typeIntereptor"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "_disabledChangeHandler", [_dec26, _dec27], Object.getOwnPropertyDescriptor(_class2.prototype, "_disabledChangeHandler"), _class2.prototype)), _class2)) || _class);
//# sourceMappingURL=Button.js.map